export const MATCH_POSTAL_CODE = /^\d+$/;
const MAX_LENGTH_POSTAL_CODES = 3;

/**
 * Formatte les codes postaux d'une ville
 * @example
 * 			Une ville a 1 code postal → 00000
 * 			Une ville a 3 codes postaux → 00000, 00001, 00002
 * 			Une ville a 4 codes postaux ou plus → 00000, 00001, ..., 00003
 */
export function formatPostalCodes(postalCodes: string[]): string {
    if (postalCodes.length > MAX_LENGTH_POSTAL_CODES) {
        const lastCode = postalCodes[postalCodes.length - 1];
        const formattedCodes = `${postalCodes.slice(0, MAX_LENGTH_POSTAL_CODES - 1).join(', ')}`;

        return `${formattedCodes}, ..., ${lastCode}`;
    }

    return postalCodes.join(', ');
}

/**
 * Récupère le nom de la ville avec les codes postaux tronqués
 * @example Paris, 75000, 75100, 75101, Paris → Paris, 75000, ..., 75101, Paris
 */
export function formatCityDisplayedName(name: string, postalCodes: string[], department: string): string {
    return `${name}, ${formatPostalCodes(postalCodes)}, ${department}`;
}